/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
    // Target the section that holds the form
    var section = document.getElementById("shopify-section-sections--16169890250918__custom_html_V7UjYb");
    if (section) {
        section.style.width = "100%";
        section.style.maxWidth = "100%";
        section.style.padding = "18px 0";
        section.style.margin = "0";
    }

    // Ensure the container inside the section is full width on mobile, but controlled on desktop
    var container = section.querySelector(".container");
    if (container) {
        container.style.width = "100%";
        container.style.maxWidth = "1200px"; // Restrict max-width on desktop
        container.style.padding = "0";
        container.style.margin = "0 auto";
    }

    // Do not touch the #sib-container (form container) to avoid affecting the form itself
});


